// Client for /api/profile (backend/chainlit/profile_api.py).

export type AboutSource = 'manual' | 'chatgpt' | 'claude';

export interface AboutLine {
  text: string;
  source: AboutSource;
  added_at?: string | null;
}

export interface Profile {
  display_name: string | null;
  job_title: string | null;
  focus: string | null;
  answer_style: string | null;
  about: AboutLine[];
  updated_at: string | null;
}

async function call<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, init);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
  return res.json();
}

export const getProfile = () => call<Profile>('/api/profile');

export const saveProfile = (p: Omit<Profile, 'updated_at'>) =>
  call<Profile>('/api/profile', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(p)
  });

export const splitImport = (text: string, source: AboutSource) =>
  call<{ source: AboutSource; lines: { text: string }[] }>('/api/profile/import', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text, source })
  });

// Pasted into ChatGPT or Claude. Asks for a plain list so the reply splits
// into lines without another model call, and asks it to leave out what no
// profile should hold.
export const IMPORT_PROMPT =
  'List what you remember about me that would help a business analytics ' +
  "assistant answer questions about my company's data: my role, my company " +
  'and its industry, the branches, products, regions or teams I look after, ' +
  'how I like answers presented, and the business terms I use. One short ' +
  'fact per line, each starting with "- ". Leave out passwords, account ' +
  'numbers, contact details and anything personal that is not about my work.';
